import {Component, ContentChild, Input, OnChanges, OnInit, SimpleChanges, TemplateRef} from '@angular/core';
import {TCTableComponent} from '../table.component';

@Component({
  selector: 'tc-table-col',
  templateUrl: './col.component.html',
  styleUrls: ['./col.component.scss']
})
export class TCTableColComponent implements OnInit, OnChanges {
  @ContentChild('tableTDTemplate') tdTemplate: TemplateRef<any>;
  @ContentChild('headerBodyTemplate') headerTemplate: TemplateRef<any>;

  @Input() columnTitle: string;
  @Input() columnName: string;
  @Input() enableFiltering: boolean;
  @Input() enableSorting: boolean;

  config: any;

  constructor(private table: TCTableComponent) {
    this.enableFiltering = false;
    this.enableSorting = false;
    this.columnName = '';
    this.columnTitle = '';

    this.config = {
      title: '',
      name: '',
      sort: '',
      enableSorting: this.enableSorting,
      filter: this.enableFiltering,
      filtering: {
        filterString: '',
        columnName: name
      }
    };
  }

  ngOnChanges(changes: SimpleChanges) {
    // console.log(changes, this.columnTitle);
    this.columnTitle = changes.columnTitle.currentValue;
    this.config.title = this.columnTitle;
  }

  ngOnInit() {
    this.setConfig();
    this.table.addColumn(this);
  }

  setConfig() {
    this.config.name = this.columnName;
    this.config.title = this.columnTitle;
    this.config.filtering.columnName = this.columnName;
    this.config.enableSorting = this.enableSorting;

    if (this.columnName === '') {
      this.config.filtering = false;
    }
  }
}
